import { BaseContainerModel } from '../base-container.model';
import { 
  bl_fi_generic_doc_template_attachment_RowClass,
  bl_fi_generic_doc_template_event_RowClass,
  bl_fi_generic_doc_template_hdr_RowClass,
  bl_fi_generic_doc_template_hdr_RowInterface,
  bl_fi_generic_doc_template_line_RowClass,
} from "../../dbschema";

export class GenericDocTemplateContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_template_hdr: bl_fi_generic_doc_template_hdr_RowInterface = new bl_fi_generic_doc_template_hdr_RowClass();
  bl_fi_generic_doc_template_line: bl_fi_generic_doc_template_line_RowClass[] = [];
  bl_fi_generic_doc_template_attachment: bl_fi_generic_doc_template_attachment_RowClass[] = [];
  bl_fi_generic_doc_template_event: bl_fi_generic_doc_template_event_RowClass[] = [];
}
